import React from 'react';
import { Header } from 'semantic-ui-react';
export default (function () {
  return /*#__PURE__*/React.createElement(Header, {
    as: "h4",
    color: "green",
    style: {
      marginTop: '0'
    }
  }, "Successfully sent!");
});